import {AuthService} from '../services/auth.service';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment} from '@angular/router';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsLoggedInGuard implements CanLoad, CanActivate {
  constructor(private router: Router, private auth: AuthService ) {

  }

  // Validates the current session token with the server to see if user is still logged in
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return new Observable((observer) => {
      this.auth.validateSession().subscribe(
        result => {
          observer.next(true);
          observer.complete();
        },
        error => {
          observer.next(false);
          observer.complete();
          this.router.navigate(['/login']);
        }
      );
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return new Observable((observer) => {
      this.auth.validateSession().subscribe(
        result => {
          observer.next(true);
          observer.complete();
        },
        error => {
          observer.next(false);
          observer.complete();
          this.router.navigate(['/login']);
        }
      );
    });
  }
}
